import { Component , OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { HttpUtils } from 'common';

@Component({
    selector: 'network-extension-embed2',
    template: require('./network-extension-embed2.html')
})

export default class NetworkExtensionEmbed2 implements OnInit {

    public iframeUrl;
    constructor(private sanitizer: DomSanitizer) {
        this.iframeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(`${HttpUtils.getUiMountPoint()}/extended-network-ui/index.html`);
    }

    ngOnInit() {}
}



// WEBPACK FOOTER //
// ./src/app/components/network-extension2/network-extension-embed2.ts